import { useState, useEffect, useRef } from 'react';
import styles from './UploadRetainerAgreement.module.scss';

type Props = {
    src: string;
    getFile?: (file: File) => void;
};

const UploadRetainerAgreement = ({ src, getFile }: Props) => {
    const [selectedFile, setSelectedFile] = useState<File | null>(null);
    const [image, setImage] = useState<string | ArrayBuffer | null>(null);
    const imgPickerRef = useRef<HTMLInputElement | null>(null);

    useEffect(() => {
        setImage(src);
    }, [src]);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file: File | null = event.target.files ? event.target.files[0] : null;
        setSelectedFile(file);

        if (getFile && file) {
            getFile(file);
        }

        const fileData: FileReader = new FileReader();
        fileData.onloadend = handleFile;

        if (file) {
            fileData.readAsDataURL(file);
        }
    };

    const pickFile = () => {
        if (imgPickerRef) {
            imgPickerRef.current?.click();
        }
    };

    const handleFile = (ev: ProgressEvent<FileReader>) => {
        if (ev?.target) {
            const content: string | ArrayBuffer | null = ev.target.result;
            setImage(content);
        }
    };

    return (
        <div>
            <input
                className={styles.fileInput}
                ref={imgPickerRef}
                type="file"
                accept="file_extension, .doc, .docx, .pdf, .txt,"
                onChange={handleChange}
            />
            <button
                className="round-button right mb-3"
                style={{ width: 356, height: 40 }}
                onClick={pickFile}
            >
                Upload own template{/* <CameraIcon /> */}
            </button>
            {(selectedFile || src) && (
                <a href={image as string} className={styles.viewAgreementLink}>
                    {selectedFile ? selectedFile.name : 'View Uploaded Retainer Agreement'}
                </a>
            )}
        </div>
    );
};

export default UploadRetainerAgreement;
